const config = window.MyAppConfig
export default config